export const isPrerender = () => {
  return window.navigator.userAgent === 'ReactSnap';
};
